import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "select_tab_box _130" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "search_wrap input_wrap",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = { class: "sign_form custom_scroll" }
const _hoisted_8 = { class: "common_table custom_scroll" }
const _hoisted_9 = { style: {"max-height":"600px","overflow-y":"auto"} }
const _hoisted_10 = { class: "cnt" }
const _hoisted_11 = { class: "cnt p_5" }
const _hoisted_12 = { class: "cnt" }
const _hoisted_13 = { class: "cnt p_5" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ActionCitizenAddModal = _resolveComponent("ActionCitizenAddModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("p", null, "액션 시민 추가", -1)),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["selected_tab", [$setup.state.isShowSearchType ? 'active' : '']]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isShowSearchType = !$setup.state.isShowSearchType))
          }, [
            _createElementVNode("span", null, _toDisplayString($setup.state.detailTxt), 1)
          ], 2),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["tab_option", [$setup.state.isShowSearchType ? 'active' : '']])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.search_type_list, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.key,
                onClick: ($event: any) => {
                            $setup.state.searchType = item.key;
                            $setup.state.detailTxt = item.value;
                            $setup.state.isShowSearchType = false;
                            if (item.key === 'all' || item.value === '전체') {
                                $setup.state.currentPage = 1;
                                $setup.getList();
                            }
                        }
              }, _toDisplayString(item.value), 9, _hoisted_5))
            }), 128))
          ], 2), [
            [_vShow, $setup.state.isShowSearchType]
          ])
        ]),
        _createElementVNode("div", null, [
          ($setup.state.searchType == 'gender' || $setup.state.searchType == '3' || $setup.state.searchType == '성별')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                class: "gender_select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.searchText) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => {
                            $setup.state.currentPage = 1;
                            $setup.getList();
                        })
              }, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("option", { value: "" }, "전체", -1),
                _createElementVNode("option", { value: "M" }, "남자", -1),
                _createElementVNode("option", { value: "F" }, "여자", -1),
                _createElementVNode("option", { value: "E" }, "기타", -1)
              ]))], 544)), [
                [_vModelSelect, $setup.state.searchText]
              ])
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.searchText) = $event)),
                  onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => {
                                $setup.state.currentPage = 1;
                                $setup.getList();
                            }, ["enter"])),
                  placeholder: "검색어를 입력하세요."
                }, null, 544), [
                  [_vModelText, $setup.state.searchText]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "search_btn icon_wrap",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                $setup.state.currentPage = 1;
                                $setup.getList();
                            }),
                  style: {"margin-left":"4px"}
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("img", {
                    src: "img/search_btn.png",
                    alt: "검색"
                  }, null, -1)
                ]))])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", null, [
            _cache[16] || (_cache[16] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"60px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"150px"} }),
              _createElementVNode("col", { style: {"width":"40px"} }),
              _createElementVNode("col", { style: {"width":"130px"} }),
              _createElementVNode("col", { style: {"width":"60px"} })
            ], -1)),
            _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { rowspan: "2" }, "번호"),
                _createElementVNode("th", { rowspan: "2" }, "이름"),
                _createElementVNode("th", { rowspan: "2" }, "닉네임"),
                _createElementVNode("th", { rowspan: "2" }, "아이디"),
                _createElementVNode("th", { rowspan: "2" }, "성별"),
                _createElementVNode("th", { rowspan: "2" }, "전화번호"),
                _createElementVNode("th", { rowspan: "2" }, "등록")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_9, [
              ($setup.state.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.idx
                    }, [
                      _createElementVNode("td", _hoisted_10, _toDisplayString($setup.CommonUtils.numberFormat(($setup.state.currentPage - 1) * $setup.state.perPage + (idx + 1))), 1),
                      _createElementVNode("td", null, _toDisplayString(item.memberVO.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.nickname), 1),
                      _createElementVNode("td", null, _toDisplayString(item.memberVO.id), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString($setup.getGenderText(item.gender)), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString($setup.CommonUtils.convertPhoneNumReal(item.phone)), 1),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "table_btn _blue",
                          onClick: ($event: any) => ($setup.showNicknameModal(item))
                        }, "등록", 8, _hoisted_14)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("td", { colspan: "6" }, [
                      _createElementVNode("div", {
                        class: "tb_subject",
                        style: {"text-align":"center","width":"100%"}
                      }, "데이터가 없습니다.")
                    ], -1)
                  ]))]))
            ])
          ])
        ]),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 0,
              currentPage: $setup.state.currentPage,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.perPage,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.modal.tab,
          title: $setup.modal.title,
          content: $setup.modal.content,
          onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: _cache[9] || (_cache[9] = () => {})
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowNicknameModal)
      ? (_openBlock(), _createBlock(_component_ActionCitizenAddModal, {
          key: 1,
          data: $setup.state.selectCitizen,
          onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.isShowNicknameModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["data", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}